const EM_DASH = "—";

export function fmt(n: number | null | undefined): string {
  return n === null || n === undefined ? EM_DASH : n.toLocaleString();
}

export function pct(rate: number | null | undefined): string {
  return rate === null || rate === undefined ? EM_DASH : `${Math.round(rate * 100)}%`;
}

export function money(n: number | null | undefined): string {
  if (n === null || n === undefined) return EM_DASH;
  return n.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
}

/** "Aug 4, 05:12 PM" — short enough for the meta strip. */
export function timestamp(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** `unsafe_structure` → `unsafe structure`, for badge labels. */
export function humanise(flag: string): string {
  return flag.replace(/_/g, " ");
}

/** Flags that mean "structural, act now" get the placard red. */
const SEVERE = new Set(["unsafe_structure", "lien_recorded"]);
const WARNING = new Set(["homestead_lost", "milestone_due", "expired_permit",
                         "tax_delinquent"]);

export function flagTone(flag: string): "b-red" | "b-amber" | "b-grey" {
  if (SEVERE.has(flag)) return "b-red";
  if (WARNING.has(flag)) return "b-amber";
  return "b-grey";
}
